<template>
    <div class="flex flex-col gap-0.5 py-3 first:pt-0 last:pb-0">
        <!-- Icon and name -->
        <div class="flex items-center gap-2">
            <component :is="isUrgentDelivery ? UrgentDeliveryTruckIcon : NormalDeliveryTruckIcon" aria-hidden="true" />
            <span class="font-extrabold" v-text="shippingOption.name" />
        </div>

        <!-- Urgent delivery and today delivery -->
        <span v-if="isUrgentDelivery && shippingOption.is_today_delivery" v-text="$t('general.delivery_options.today_delivery.label')" />

        <!-- Urgent delivery and tomorrow delivery -->
        <span
            v-else-if="isUrgentDelivery && shippingOption.is_tomorrow_delivery"
            v-safe-html="$t('general.delivery_options.tomorrow_delivery.label')"
        />

        <!-- Day after tomorrow delivery -->
        <span v-else-if="isUrgentDelivery && isDayAfterTomorrowDelivery" v-safe-html="$t('general.delivery_options.day_after_tomorrow.label')" />

        <!-- Readable date -->
        <span v-else v-safe-html="_.upperFirst(shippingOption.readable_date)" />

        <!-- Optional delivery option label -->
        <span
            v-if="shippingOption.delivery_option_label && shippingOption.delivery_option_label?.label"
            class="mt-2 flex w-fit items-center gap-2 rounded-full bg-delivery-option-label px-4 py-1.5 font-semibold text-delivery-option-label-text"
        >
            <img
                v-if="shippingOption.delivery_option_label.image_url"
                :src="shippingOption.delivery_option_label.image_url"
                :alt="shippingOption.delivery_option_label.label"
                class="h-6 w-6"
            />
            <span>{{ shippingOption.delivery_option_label.label }}</span>
        </span>
    </div>
</template>

<script setup lang="ts">
import NormalDeliveryTruckIcon from '@/icons/shipping/NormalDeliveryTruckIcon.vue';
import UrgentDeliveryTruckIcon from '@/icons/shipping/UrgentDeliveryTruckIcon.vue';
import { MagentoPaazlShippingOptionObject } from '@/types/generated';
import _ from 'lodash';
import { computed } from 'vue';

type ProductShippingOptionProps = {
    shippingOption: MagentoPaazlShippingOptionObject;
};

const props = defineProps<ProductShippingOptionProps>();

const isUrgentDelivery = ['SHIPPING_URGENT', 'SHIPPING_FAST'].includes(props.shippingOption.identifier);

const isDayAfterTomorrowDelivery = computed<boolean>(
    () => !props.shippingOption.is_today_delivery && !props.shippingOption.is_tomorrow_delivery && props.shippingOption.is_after_day_after_tomorrow,
);
</script>
